<bn-loading-overlay></bn-loading-overlay>

<h5>Cálculo do valor honrado a recuperar</h5>

<section class="container">
  <div class="mb-3 row">
    <div class="col">
      <h3>Filtros de pesquisa</h3>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-success no-margin" (click)="calcular()" [disabled]="!filtrosValidos()">Calcular</button>
    </div>
  </div>

  <div class="row"  (keyup.enter)="filtrosValidos() ? calcular() : null" >
    <div class="col-md-3">
      <label>Data de referência: </label>
      <bn-datepicker [(ngModel)]="dataReferencia" name="dataReferencia"></bn-datepicker>
    </div>
    <div class="col-md-3">
      <label for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
      </label>
      <select id="sistema" class="form-select" [(ngModel)]="sistema" [compareWith]="compararSistema">
        <option value=''></option>
        <option value='CL'>Crédito Livre</option>
        <option value='15'>15 - Contratos FINAME</option>
        <option value='89'>89 - Contratos BNDES</option>
      </select>
    </div>
    <div class="col-md-6" *ngIf="sistema == 'CL' && podeEscolherAgente">
      <label>Agente Financeiro</label>
      <select class="form-select" [compareWith]="compararPorId" [(ngModel)]="agenteFinanceiro">
          <option [ngValue]="undefined"></option>
          <option [ngValue]="agente" *ngFor="let agente of agentesFinanceiros">
              {{agente.nome}}
          </option>
      </select>
    </div>
    <div class="col-md-3" *ngIf="sistema == 'CL'">
      <label>Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
      </label>
      <input type="text" class="form-control" [(ngModel)]="idExternoOperacao">
    </div>
    <div class="col-md-2" *ngIf="sistema == '15' || sistema == '89'">
      <label>Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
        ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
      </label>
      <input type="text" class="form-control" [(ngModel)]="contrato">
    </div>
  </div>

  <div *ngIf="resultado" class="divResultado">
    <div class="row">
      <div class="col-md-3">
        <label>Data da cotação utilizada <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="A data de cotação utilizada para atualizar os valores."></i></label>
        <input type="text" class="form-control" [value]="resultado.dataCotacaoUtilizadaNaAtualizacao | date:'dd/MM/yyyy'"  disabled />
    </div>
      <div class="col-md-3">
        <label>Val. cotação utilizada<i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="O valor de cotação da U.M. 143 na data de referência (para atualização dos valores) ou o último valor de cotação disponível anterior à data de referência."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorCotacaoUtilizadoNaAtualizacao | number:'1.6-6'" disabled>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label>Val. honra hist. <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor da honra histórico."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorHonraHistorico | bnMask:'MOEDA'" disabled>
      </div>
      <div class="col-md-3">
        <label>Val. honra atu. <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor da honra atualizado."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorHonraAtualizadoAteDataReferencia | bnMask:'MOEDA'" disabled>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label>Val. rev. honra hist. <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor de reversão honra histórico."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorReversaoHonraHistorico | bnMask:'MOEDA'" disabled>
      </div>
      <div class="col-md-3">
        <label>Val. rev. honra excedente <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor de reversão honra excedente (valor que supera o valor histórico da honra)."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorReversaoHonraExcedente | bnMask:'MOEDA'" disabled>
      </div>
      <div class="col-md-3">
        <label>Val. rev. atu. <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor de reversão atualizado."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorTotalReversaoHonraAtualizadoAteDataReferencia | bnMask:'MOEDA'" disabled>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label>Val. rec. credt. hist. <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor de recuperação de crédito histórico (valor total de recuperação repassado ao {{nomeModalidade}})."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorRecuperacaoCreditoHistorico | bnMask:'MOEDA'" disabled>
      </div>
      <div class="col-md-3">
        <label>Val. rec. credt. excedente <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor de recuperação de crédito excedente (valor total de recuperação repassado acima do valor histórico da honra)."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorRecuperacaoCreditoExcedente | bnMask:'MOEDA'" disabled>
      </div>
      <div class="col-md-3">
        <label>Val. rec. credt. atu. <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor de recuperação de crédito atualizado."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorTotalRecuperacaoAtualizadoAteDataReferencia | bnMask:'MOEDA'" disabled>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label>Val. honrado a recuperar hist. <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor honrado a recuperar histórico."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorHonradoARecuperarHistorico | bnMask:'MOEDA'" disabled>
      </div>
      <div class="col-md-3">
        <label><strong>Val. honrado a recuperar atu. * </strong> <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Valor honrado a recuperar atualizado."></i></label>
        <input type="text" class="form-control" [value]="resultado.valorHonradoARecuperarAtualizado | bnMask:'MOEDA'" disabled>
        <small>* O cálculo não considera as recuperações informadas pelo Agente Financeiro que ainda estejam pendentes de pagamento.</small>
      </div>
      <div>
    </div>
  </div>
  </div>
</section>

